import React, { useState } from 'react';
import styled from 'styled-components/macro';
import { useDispatch, useSelector } from 'react-redux';

import actions from 'state/actions';
import selectors from 'state/selectors';
import utils from 'utils';
import services from 'services';

import Modal from 'components/Modal';
import TextInput from 'components/Input/TextInput';
import Dropdown from 'components/Input/dropdown/Dropdown';

export const InputsContainer = styled.div`
  text-align: center;
`;

export const InputContainer = styled.div`
  display: flex;
  justify-content: center;
  padding: 5px;
`;

const languages = [
  { label: 'English', value: 'EN' },
  { label: 'German', value: 'DE' },
  { label: 'Spanish', value: 'ES' },
  { label: 'French', value: 'FR' },
  { label: 'Portuguese', value: 'PT' },
  { label: 'Chinese', value: 'ZH' },
  { label: 'Japanese', value: 'JA' },
  { label: 'Korean', value: 'KO' },
  { label: 'Russian', value: 'RU' },
  { label: 'Dutch', value: 'NL' },
  { label: 'Italian', value: 'IT' },
  { label: 'Danish', value: 'DA' },
  { label: 'Finnish', value: 'FI' },
  { label: 'Swedish', value: 'SV' },
  { label: 'Norwegian', value: 'NO' },
  { label: 'Polish', value: 'PL' },
  { label: 'Czech', value: 'CS' },
  { label: 'Hungarian', value: 'HU' },
  { label: 'Romanian', value: 'RO' },
  { label: 'Turkish', value: 'TR' },
  { label: 'Arabic', value: 'AR' },
  { label: 'Hebrew', value: 'HE' },
  { label: 'Greek', value: 'EL' },
  { label: 'Thai', value: 'TH' },
  { label: 'Slovak', value: 'SK' },
];

const SapUserLogin = () => {
  const dispatch = useDispatch();
  const t = utils.intl.useTranslator();
  const modalProps = useSelector(selectors.modal.getModalProps);

  const [username, setUsername] = useState<string>('');
  const [password, setPassword] = useState<string>('');
  const [language, setLanguage] = useState<{ label: string; value: string } | null>(null);

  const setCredentials = async () => {
    const { environment, port, exportToSap } = modalProps;
    try {
      const data = await services.sapSetCredentials({
        data: {
          environment,
          username,
          password,
          language: language?.value ?? null,
        },
        port,
      });
      utils.app.notify('success', t(data));
      dispatch(actions.modal.closeModal());
      exportToSap();
    } catch (e) {
      console.error(e);
      utils.app.notify('fail', e as string, 3000);
    }
  };

  return (
    <>
      <Modal.Header title={t('sap_user_login')} />
      <Modal.Content>
        <InputsContainer>
          <InputContainer>
            <TextInput
              id="sap-username"
              name="sap_username"
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => setUsername(e.target.value)}
              placeholder={t('username')}
              value={username}
            />
          </InputContainer>
          <InputContainer>
            <TextInput
              id="sap-password"
              name="sap_password"
              type="password"
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => setPassword(e.target.value)}
              placeholder={t('password')}
              value={password}
            />
          </InputContainer>
          <InputContainer>
            <Dropdown
              id="language-dropdown"
              name="language"
              placeholder={t('language')}
              value={language}
              onChange={(option) => {
                setLanguage(option);
              }}
              options={languages}
              isClearable
              width="200px"
            />
          </InputContainer>
        </InputsContainer>
      </Modal.Content>
      <Modal.Footer
        confirmText={t('continua')}
        confirmAction={setCredentials}
        confirmDisabled={!username || !password}
        closeButtonText={t('chiudi')}
      />
    </>
  );
};

export default SapUserLogin;
